// src/utils/pageStyles.js — Design tokens partagés pour toutes les pages

// ── Palette statuts ───────────────────────────────────────────────────────────
export const STATUS_META = {
  running:   { color: "#22c55e", bg: "#f0fdf4", label_fr: "En cours",  label_en: "Running"   },
  scheduled: { color: "#6366f1", bg: "#eef2ff", label_fr: "Planifiée", label_en: "Scheduled" },
  completed: { color: "#64748b", bg: "#f8fafc", label_fr: "Terminée",  label_en: "Done"      },
  cancelled: { color: "#f59e0b", bg: "#fffbeb", label_fr: "Annulée",   label_en: "Cancelled" },
  failed:    { color: "#ef4444", bg: "#fef2f2", label_fr: "Échouée",   label_en: "Failed"    },
};

// ── Tokens couleurs ───────────────────────────────────────────────────────────
export const C = {
  primary:  "#6366f1",
  primary2: "#4f46e5",
  green:    "#22c55e",
  green_bg: "#f0fdf4",
  green_br: "#bbf7d0",
  amber:    "#f59e0b",
  amber_bg: "#fffbeb",
  red:      "#ef4444",
  red_bg:   "#fef2f2",
  slate:    "#64748b",
  slate_bg: "#f8fafc",
  border:   "#e2e8f0",
  bg_hover: "#f8fafc",
};

// ── sx helpers ────────────────────────────────────────────────────────────────
export const pageWrap = {
  maxWidth: 1200, mx: "auto", my: 4, px: { xs: 2, md: 3 }
};

export const card = {
  elevation: 0,
  sx: {
    border: "1px solid", borderColor: "divider", borderRadius: 3,
    "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,.06)" },
    transition: "box-shadow .2s",
  }
};

export const cardHeader = {
  px: 3, py: 2,
  borderBottom: "1px solid", borderColor: "divider",
};

export const tableHeaderCell = {
  fontWeight: 600, fontSize: 12, color: "text.secondary", bgcolor: "#f8fafc",
};

export const tableRow = {
  "&:hover": { bgcolor: "#f8fafc" },
  "&:last-child td": { border: 0 },
  transition: "background .15s",
};

export const btnPrimary = {
  borderRadius: 2,
  bgcolor: "#6366f1",
  "&:hover": { bgcolor: "#4f46e5" },
};

export const btnIcon = (color = "#6366f1", bgHover = "#eef2ff") => ({
  color,
  "&:hover": { bgcolor: bgHover },
  "&.Mui-disabled": { opacity: .3 },
});

export const refreshBtn = {
  border: "1px solid", borderColor: "divider", borderRadius: 2,
};

// ── Composant StatusBadge (inline, pas de JSX ici) ──────────────────────────
export function statusSx(rawStatus, isRunning = false) {
  const s = isRunning ? "running" : String(rawStatus || "scheduled").toLowerCase().trim();
  const m = STATUS_META[s] || { color: "#64748b", bg: "#f8fafc" };
  return {
    display: "inline-flex", alignItems: "center", gap: 0.5,
    px: 1.5, py: 0.4, borderRadius: 2,
    bgcolor: m.bg, color: m.color,
    fontSize: 11, fontWeight: 700, letterSpacing: 0.5, whiteSpace: "nowrap",
    color: m.color,
  };
}

export function minutesFmt(n) {
  const v = Number(n || 0);
  if (v === 0) return "0 min";
  if (Math.abs(v) < 60) return `${v.toFixed(0)} min`;
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  const h = Math.floor(abs / 60);
  const m = Math.round(abs % 60);
  if (m === 0) return `${sign}${h} h`;
  return `${sign}${h} h ${m} min`;
}
